var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoginForm',{attrs:{"error":_vm.errorMessage},on:{"sign-in":_vm.signIn}})}
var staticRenderFns = []

export { render, staticRenderFns }